<template>
	<el-dialog title="提示" :show-close="false" :visible.sync="visible" width="922px" :close-on-click-modal="false" :before-close="handleClose">
		<div slot="title"></div>
		<div class="flex-row-align-center flex-just-between">
			<p></p>
			<p class="font-h1-medium yx-color-text-primary">新手引导</p>
			<i class="el-icon-close font-h3-regular cursor-pointer hover" @click="handleClose"></i>
		</div>
		<div class="flex-row" style="margin-top: 40px">
			<div style="width: 170px">
				<p class="font-h4-medium yx-color-text-primary">👏 欢迎使用超佣团</p>
				<p class="yx-color-text-secondary font-h6-regular mt-8">商团协作请按以下步骤操作</p>
				<div class="mt-16" style="height: 300px">
					<el-steps direction="vertical" :active="active" finish-status="success">
						<el-step title="协作规则设置"></el-step>
						<el-step title="商团绑定协作关系"></el-step>
						<el-step title="选品申样"></el-step>
						<el-step title="样品同步至商家侧"></el-step>
					</el-steps>
				</div>
			</div>
			<div style="margin-left: 40px" class="flex-1 yx-background radius-12">
				<div class="yx-background-white radius-16">
					<img :src="require('@/assets/public/new-guide-img' + (active > 3 ? 4 : active + 1) + '.png')" alt="" />
					<!-- <img src="@/assets/public/new-guide-img1.png" alt="" /> -->
				</div>
			</div>
		</div>
		<div
			class="pt-8 pb-8 yx-color-white font-h4-regular text-align-center cursor-pointer radius-4"
			style="background-color: #2475ff; margin-top: 40px"
			@click="goToGuide"
		>
			立即前往
		</div>
	</el-dialog>
</template>
<script>
import { cooperateInductionTip } from '@/api/common';
export default {
	props: {
		isApi: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			visible: false,
			active: 0,
		};
	},
	created() {
		if (this.isApi) this.getTips('1');
	},
	methods: {
		show() {
			this.visible = true;
			this.getTips();
		},
		async getTips(type = '') {
			const { isShow = false, step = {} } = await cooperateInductionTip();
			if (type) this.visible = isShow;
			this.active = Object.values(step).filter(item => item).length || 0;
		},
		handleClose() {
			this.visible = false;
		},
		goToGuide() {
			const url = {
				1: '/cooperativeShop/collaborateRules/viewRules',
				2: '/teamManage/delegationhead',
				3: '/shopManage/shopLibrary/list',
				4: '/sample/list',
			};
			const { href } = this.$router.resolve({
				path: url[this.active > 3 ? 4 : this.active + 1],
			});
			window.open(href, '_blank');
			this.$router.resolve;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__header {
	border-bottom: none;
	padding: 0px;
}
/deep/ .el-dialog__footer {
	padding: 0px;
}
/deep/ .el-dialog__body {
	padding: 40px !important;
}
</style>
